import { restApi } from '../../../api';
import {
  FindAccountsReceivableInstallmentsFilterOptionsOutput,
  FindAccountsReceivableInstallmentsFilterOptionsParams,
  FindBrandsFilterOptionsOutput,
  FindBrandsFilterOptionsParams,
  FindCaseFilterOptionsOutput,
  FindCaseFilterOptionsParams,
  FindCaseStatusFilterOptionsOutput,
  FindCaseStatusFilterOptionsParams,
  FindCaseUsersFilterOptionsOutput,
  FindCaseUsersFilterOptionsParams,
  FindCatalogAccessClassificationsFilterOptionsOutput,
  FindCatalogAccessClassificationsFilterOptionsParams,
  FindCatalogsFilterOptionsOutput,
  FindCatalogsFilterOptionsParams,
  FindCategoriesFilterOptionsOutput,
  FindCategoriesFilterOptionsParams,
  FindCitiesFilterOptionsOutput,
  FindCitiesFilterOptionsParams,
  FindClassificationsFilterOptionsOutput,
  FindClassificationsFilterOptionsParams,
  FindCollectionsFilterOptionsOutput,
  FindCollectionsFilterOptionsParams,
  FindColorsFilterOptionsOutput,
  FindColorsFilterOptionsParams,
  FindConsultantsFilterOptionsOutput,
  FindConsultantsFilterOptionsParams,
  FindCustomerGroupsFilterOptionsOutput,
  FindCustomerGroupsFilterOptionsParams,
  FindCustomersFilterOptionsOutput,
  FindCustomersFilterOptionsParams,
  FindDeliveryWindowsFilterOptionsOutput,
  FindDeliveryWindowsFilterOptionsParams,
  FindInvoicesFilterOptionsOutput,
  FindInvoicesFilterOptionsParams,
  FindLocalsFilterOptionsOutput,
  FindLocalsFilterOptionsParams,
  FindLocalsStatesFilterOptionsOutput,
  FindLocalsStatesFilterOptionsParams,
  FindOrderVouchersFilterOptionsOutput,
  FindOrderVouchersFilterOptionsParams,
  FindOrdersFilterOptionsOutput,
  FindOrdersFilterOptionsParams,
  FindParentOrdersFilterOptionsOutput,
  FindParentOrdersFilterOptionsParams,
  FindPriceTablesFilterOptionsOutput,
  FindPriceTablesFilterOptionsParams,
  FindProductsFilterOptionsOutput,
  FindProductsFilterOptionsParams,
  FindPromotionCodesFilterOptionsOutput,
  FindPromotionCodesFilterOptionsParams,
  FindReferenceColorsFilterOptionsOutput,
  FindReferenceColorsFilterOptionsParams,
  FindSalesOpportunityFilterOptionsOutput,
  FindSalesOpportunityFilterOptionsParams,
  FindSalesRepresentativesFilterOptionsOutput,
  FindSalesRepresentativesFilterOptionsParams,
  FindSalesTargetsFilterOptionsOutput,
  FindSalesTargetsFilterOptionsParams,
  FindSellersFilterOptionsOutput,
  FindSellersFilterOptionsParams,
  FindSizesFilterOptionsOutput,
  FindSizesFilterOptionsParams,
  FindSkuCodesFilterOptionsOutput,
  FindSkuCodesFilterOptionsParams,
  FindStatesFilterOptionsOutput,
  FindStatesFilterOptionsParams,
  FindSuggestedCopiesFilterOptionsOutput,
  FindSuggestedCopiesFilterOptionsParams,
} from '../filterOptions.types';
import {
  FindAdminTeamsFilterOptionsOutput,
  FindAdminTeamsFilterOptionsParams,
} from '../filterOptions.types';

export const PATH = 'filter-options';

const onlineFilterOptionsRepository = () => {
  return {
    path: PATH,
    findAdminTeamsFilterOptions: (params: FindAdminTeamsFilterOptionsParams) =>
      restApi.get<FindAdminTeamsFilterOptionsOutput>(`${PATH}/admin/teams`, params),

    findCitiesFilterOptions: (params: FindCitiesFilterOptionsParams) =>
      restApi.get<FindCitiesFilterOptionsOutput>(`${PATH}/cities`, params),

    findCustomersFilterOptions: (params: FindCustomersFilterOptionsParams) =>
      restApi.get<FindCustomersFilterOptionsOutput>(`${PATH}/customers`, params),

    findPriceTablesFilterOptions: (params: FindPriceTablesFilterOptionsParams) =>
      restApi.get<FindPriceTablesFilterOptionsOutput>(`${PATH}/price-tables`, params),

    findStatesFilterOptions: (params: FindStatesFilterOptionsParams) =>
      restApi.get<FindStatesFilterOptionsOutput>(`${PATH}/states`, params),

    findCustomerGroupsFilterOptions: (params: FindCustomerGroupsFilterOptionsParams) =>
      restApi.get<FindCustomerGroupsFilterOptionsOutput>(`${PATH}/customer-groups`, params),

    findSalesRepresentativesFilterOptions: (params: FindSalesRepresentativesFilterOptionsParams) =>
      restApi.get<FindSalesRepresentativesFilterOptionsOutput>(
        `${PATH}/sales-representatives`,
        params,
      ),

    findSalesTargetsFilterOptions: (params: FindSalesTargetsFilterOptionsParams) =>
      restApi.get<FindSalesTargetsFilterOptionsOutput>(`${PATH}/sales-targets`, params),

    findOrdersFilterOptions: (params: FindOrdersFilterOptionsParams) =>
      restApi.get<FindOrdersFilterOptionsOutput>(`${PATH}/orders`, params),

    findParentOrdersFilterOptions: (params: FindParentOrdersFilterOptionsParams) =>
      restApi.get<FindParentOrdersFilterOptionsOutput>(`${PATH}/parent-orders`, params),

    findSellersFilterOptions: (params: FindSellersFilterOptionsParams) =>
      restApi.get<FindSellersFilterOptionsOutput>(`${PATH}/sellers`, params),

    findCollectionsFilterOptions: (params: FindCollectionsFilterOptionsParams) =>
      restApi.get<FindCollectionsFilterOptionsOutput>(`${PATH}/collections`, params),

    findLocalsFilterOptions: (params: FindLocalsFilterOptionsParams) =>
      restApi.get<FindLocalsFilterOptionsOutput>(`${PATH}/locals`, params),

    findProductsFilterOptions: (params: FindProductsFilterOptionsParams) =>
      restApi.get<FindProductsFilterOptionsOutput>(`${PATH}/products`, params),

    findStoreProductsFilterOptions: (params: FindProductsFilterOptionsParams) =>
      restApi.get<FindProductsFilterOptionsOutput>(`${PATH}/store-products`, params),

    findKitsFilterOptions: (params: FindProductsFilterOptionsParams) =>
      restApi.get<FindProductsFilterOptionsOutput>(`${PATH}/kits`, params),

    findLocalsStatesFilterOptions: (params: FindLocalsStatesFilterOptionsParams) =>
      restApi.get<FindLocalsStatesFilterOptionsOutput>(`${PATH}/locals/states`, params),

    findColorsFilterOptions: (params: FindColorsFilterOptionsParams) =>
      restApi.get<FindColorsFilterOptionsOutput>(`${PATH}/colors`, params),

    findStoreColorsFilterOptions: (params: FindColorsFilterOptionsParams) =>
      restApi.get<FindColorsFilterOptionsOutput>(`${PATH}/store-colors`, params),

    findReferenceColorsFilterOptions: (params: FindReferenceColorsFilterOptionsParams) =>
      restApi.get<FindReferenceColorsFilterOptionsOutput>(`${PATH}/reference-colors`, params),

    findCategoriesFilterOptions: (params: FindCategoriesFilterOptionsParams) =>
      restApi.get<FindCategoriesFilterOptionsOutput>(`${PATH}/categories`, params),

    findDeliveryWindowsFilterOptions: (params: FindDeliveryWindowsFilterOptionsParams) =>
      restApi.get<FindDeliveryWindowsFilterOptionsOutput>(`${PATH}/delivery-windows`, params),

    findSizesFilterOptions: (params: FindSizesFilterOptionsParams) =>
      restApi.get<FindSizesFilterOptionsOutput>(`${PATH}/sizes`, params),

    findClassificationsFilterOptions: (params: FindClassificationsFilterOptionsParams) =>
      restApi.get<FindClassificationsFilterOptionsOutput>(`${PATH}/classifications`, params),

    findClassificationsNoRbacFilterOptions: (params: FindClassificationsFilterOptionsParams) =>
      restApi.get<FindClassificationsFilterOptionsOutput>(
        `${PATH}/classifications/no-rbac`,
        params,
      ),

    findSalesOpportunityFilterOptions: (params: FindSalesOpportunityFilterOptionsParams) =>
      restApi.get<FindSalesOpportunityFilterOptionsOutput>(`${PATH}/sales-opportunities`, params),

    findCaseFilterOptions: (params: FindCaseFilterOptionsParams) =>
      restApi.get<FindCaseFilterOptionsOutput>(`${PATH}/cases`, params),

    findCaseStatusFilterOptions: (params: FindCaseStatusFilterOptionsParams) =>
      restApi.get<FindCaseStatusFilterOptionsOutput>(`${PATH}/case-status`, params),

    findCaseAuthorsFilterOptions: (params: FindCaseUsersFilterOptionsParams) =>
      restApi.get<FindCaseUsersFilterOptionsOutput>(`${PATH}/case-authors`, params),

    findCaseResponsiblesFilterOptions: (params: FindCaseUsersFilterOptionsParams) =>
      restApi.get<FindCaseUsersFilterOptionsOutput>(`${PATH}/case-responsibles`, params),

    findConsultantsFilterOptions: (params: FindConsultantsFilterOptionsParams) =>
      restApi.get<FindConsultantsFilterOptionsOutput>(`${PATH}/consultants`, params),

    findCatalogsFilterOptions: (params: FindCatalogsFilterOptionsParams) =>
      restApi.get<FindCatalogsFilterOptionsOutput>(`${PATH}/catalogs`, params),

    findCatalogAccessClassifications: (
      params: FindCatalogAccessClassificationsFilterOptionsParams,
    ) =>
      restApi.get<FindCatalogAccessClassificationsFilterOptionsOutput>(
        `${PATH}/catalog-access-classifications`,
        params,
      ),

    findInvoicesFilterOptions: (params: FindInvoicesFilterOptionsParams) =>
      restApi.get<FindInvoicesFilterOptionsOutput>(`${PATH}/invoices`, params),

    findSuggestedCopyOrdersFilterOptions: (params: FindSuggestedCopiesFilterOptionsParams) =>
      restApi.get<FindSuggestedCopiesFilterOptionsOutput>(`${PATH}/suggested-copies`, params),

    findOrderVouchersFilterOptions: (params: FindOrderVouchersFilterOptionsParams) =>
      restApi.get<FindOrderVouchersFilterOptionsOutput>(`${PATH}/order-vouchers`, params),

    findAccountsReceivableFilterOptions: (
      params: FindAccountsReceivableInstallmentsFilterOptionsParams,
    ) =>
      restApi.get<FindAccountsReceivableInstallmentsFilterOptionsOutput>(
        `${PATH}/accounts-receivable`,
        params,
      ),

    findBrandsFilterOptions: (params: FindBrandsFilterOptionsParams) =>
      restApi.get<FindBrandsFilterOptionsOutput>(`${PATH}/brands`, params),

    findSkuCodesFilterOptions: (params: FindSkuCodesFilterOptionsParams) =>
      restApi.get<FindSkuCodesFilterOptionsOutput>(`${PATH}/sku-codes`, params),

    findPromotionCodesFilterOptions: (params: FindPromotionCodesFilterOptionsParams) =>
      restApi.get<FindPromotionCodesFilterOptionsOutput>(`${PATH}/promotion-codes`, params),
  };
};

export default onlineFilterOptionsRepository;
